import type { FC } from "react";

import { Card, CardRowSimple, type GridCard, Tag } from "widgets";

import style from "../../core/cards/styles/Card.module.scss";

import { getGeneTypeColor } from "../../../app-utils/color.js";
import { createNuSequenceLengthString } from "../../../app-utils/string.js";
import type { Sequence } from "../../../graphql.js";
import { uploaderFieldLabel } from "../../../settings/settings.js";
import { getUserDisplayName } from "@/modules/users/utils/user.js";

export interface ISequenceCardProps extends GridCard {
  sequence: Sequence;
}

const SequenceCard: FC<ISequenceCardProps> = (props) => {
  const sequence: Sequence = props.sequence;
  if (!sequence) {
    return null;
  }

  return (
    <Card title={"Sequence Info"}>
      <CardRowSimple label={"Type"}>
        <div className={style.tags_list}>
          <Tag intentColor={getGeneTypeColor(sequence.sequenceType)}>{sequence.sequenceType}</Tag>
        </div>
      </CardRowSimple>
      <CardRowSimple label={"Sequence ID (accession.version)"} value={sequence.sequenceId} />
      <CardRowSimple label={"Name"} value={sequence.name} />
      <CardRowSimple label={"Description"} value={sequence.description} />
      <CardRowSimple label={"Length"} value={createNuSequenceLengthString(sequence.length)} />
      <CardRowSimple label={uploaderFieldLabel} value={getUserDisplayName(sequence.creator)} />
    </Card>
  );
};

export { SequenceCard };
